import { Users } from "./users";

export const UsersAndPermissions = () => {
  return <Users />;
};
